const initialState = {
  isProspect: false,
  prospect: null,
};

export const prospects = {
  state: { ...initialState },
  reducers: {
    updateIsProspect(state, payload) {
      return {
        ...state,
        isProspect: payload,
      };
    },
    updateProspect(state, payload) {
      return {
        ...state,
        prospect: payload,
      };
    },
  },
};
